import { helper } from '@ember/component/helper';

export default helper(function minutesHelper([ minutes ]) {
  return Math.floor(minutes * 60 * 1000);
});
